import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-master-user-modal',
  templateUrl: './change-master-user-modal.component.html',
  styleUrls: ['./change-master-user-modal.component.css']
})
export class ChangeMasterUserModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ChangeMasterUserModalComponent>
  ) { }

  public isLoading: boolean;

  ngOnInit(): void {
    this.isLoading = false;
  }

  close() {
    this.matDialogRef.close({ changeMasterUser: false });
  }

  updateJustMasterUser() {
    this.matDialogRef.close({ changeMasterUser: true })
  }

  clickCancel() {
    this.matDialogRef.close({ changeMasterUser: false });
  }
}